/**
 * Glass effect and widget styling constants.
 * Extracted from GlassCard.js for clean dependency direction.
 */

/** Blur intensity levels for the glass effect */
export const GLASS_BLUR_LEVELS = [
  { value: 0, label: 'None', blur: '0px' },
  { value: 1, label: 'Subtle', blur: '4px' },
  { value: 2, label: 'Light', blur: '8px' },
  { value: 3, label: 'Medium', blur: '14px' },
  { value: 4, label: 'Strong', blur: '22px' },
  { value: 5, label: 'Heavy', blur: '32px' },
];

export const DEFAULT_GLASS_BLUR = 3; // Medium

/** Widget opacity levels for controlling the background overlay transparency */
export const WIDGET_OPACITY_LEVELS = [
  { value: 0, label: 'None', opacity: 0 },
  { value: 1, label: 'Subtle', opacity: 0.03 },
  { value: 2, label: 'Light', opacity: 0.05 },
  { value: 3, label: 'Medium', opacity: 0.08 },
  { value: 4, label: 'Strong', opacity: 0.12 },
  { value: 5, label: 'Heavy', opacity: 0.18 },
];

export const DEFAULT_WIDGET_OPACITY = 2; // Light (0.05 = matches original bg-white/5)
